import { Button, Grid, IconButton, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import { RetailView } from "./RetailView";
import { BarcodeView } from "./Barcode View";

interface MenuListProps {
  selectedView: string;
}

export const MenuList: React.FC<MenuListProps> = React.memo(({ selectedView }) => {
  const [view, setView] = useState(selectedView);

  return (
    <Grid container padding={4} >
      {selectedView === "barcode view" ? (
        // Show BarcodeView component when selectedView is "barcode view"
        <BarcodeView />
      ) : (
        // Show MenuList content when selectedView is not "barcode view"
        <Grid item xs={12} sm={11}>
          <Grid container alignItems="center" gap={2}>
            {/* Categories */}
            <Grid item>
              <IconButton>
                <WSIcons.KeyboardArrowLeftIcon />
              </IconButton>
            </Grid>

            {/* First five buttons aligned in a single line */}
            {["COFFEE", "TEA", "A LA KARTE", "DRINKS", "JUICE"].map((item, index) => (
              <Grid item key={index}>
                <Button
                  variant="outlined"
                  sx={{
                    fontSize: "1rem",
                    padding: "12px 24px",
                    backgroundColor: item === "JUICE" ? "green" : "white",
                    color: item === "JUICE" ? "white" : "black",
                  }}
                >
                  {item}
                </Button>
              </Grid>
            ))}

            <Grid item>
              <IconButton>
                <WSIcons.ChevronRightIcon />
              </IconButton>
            </Grid>
          </Grid>

          {/* Additional buttons and layout */}
          <Grid container gap={2} alignItems="center" sx={{ mt: 2 }}>
            <Grid item>
              <IconButton>
                <WSIcons.KeyboardArrowLeftIcon />
              </IconButton>
            </Grid>

            <Grid item>
              <Button
                variant="outlined"
                sx={{
                  fontSize: "1rem",
                  height: "4rem",
                  width: "9rem",
                  backgroundColor: "green",
                  color: "white",
                }}
              >
                FRESH JUICE
              </Button>
            </Grid>

            <Grid item>
              <Button
                variant="outlined"
                sx={{
                  fontSize: "1rem",
                  height: "4rem",
                  width: "9rem",
                  backgroundColor: "white",
                  color: "black",
                }}
              >
                PACKET JUICE
              </Button>
            </Grid>

            <Grid item>
              <IconButton>
                <WSIcons.ChevronRightIcon />
              </IconButton>
            </Grid>
          </Grid>

          {/* Product buttons */}
          <Grid container gap={1} sx={{ mt: 2 }}>
            {["Apple Fresh Juice", "Avocado Fresh Juice", "GrapeFruit Fresh Juice", "Lime Fresh Juice", "Mango Fresh Juice"].map((item, index) => (
              <Grid item key={index}>
                <Button
                  variant="outlined"
                  sx={{
                    fontSize: "1rem",
                    height: "5rem",
                    width: "9rem",
                    backgroundColor: "white",
                    color: "black",
                  }}
                >
                  {item}
                </Button>
              </Grid>
            ))}
          </Grid>

          <Grid container gap={1} sx={{ mt: 1 }}>
            {["Orange Fresh Juice", "Papaya Fresh Juice", "Pineapple Fresh Juice", "Watermelon Fresh Juice"].map((item, index) => (
              <Grid item key={index}>
                <Button
                  variant="outlined"
                  sx={{
                    fontSize: "1rem",
                    height: "5rem",
                    width: "9rem",
                    backgroundColor: "white",
                    color: "black",
                  }}
                >
                  {item}
                </Button>
              </Grid>
            ))}
          </Grid>

          {/* Bottom section for RetailView */}
          {selectedView === "retail view" || selectedView === "item search by code" ? (
            <RetailView />
          ) : (
            <Grid container sx={{ mt: "12rem", justifyContent: "space-between" }}>
              {/* Icons for other views, hidden when RetailView is shown */}
              <IconButton>
                <WSIcons.KeyboardArrowLeftIcon />
              </IconButton>
              <Tooltip title="item style">
                <IconButton>
                  <WSIcons.AppsIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="fill color">
                <IconButton>
                  <WSIcons.FormatColorFillIcon />
                </IconButton>
              </Tooltip>
              <IconButton>
                <WSIcons.ChevronRightIcon />
              </IconButton>
            </Grid>
          )}
        </Grid>
      )}
    </Grid>
  );
});
